var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZimbabwe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40.0001C31.0455 40.0001 39.9998 31.0458 39.9998 20.0001C39.9998 8.95443 31.0455 0.00012207 19.9998 0.00012207C8.95412 0.00012207 -0.000183105 8.95443 -0.000183105 20.0001C-0.000183105 31.0458 8.95412 40.0001 19.9998 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0857 11.4534C37.0696 9.30698 35.6829 7.37081 34.0079 5.72667L20 4.34784L5.99224 5.72675C5.94755 5.77057 5.90396 5.81542 5.85974 5.85971L11.4535 11.4535L20 11.7145L38.0857 11.4534Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85947 34.1406C5.93306 34.2142 6.0065 34.2878 6.08119 34.3603L20 35.6522L33.9187 34.3603C35.6109 32.7197 37.0147 30.7834 38.0451 28.6336L12.1738 27.8261C9.94783 30.0522 7.38033 32.6195 5.85947 34.1406V34.1406Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8011 17.1801L16.5217 16.5217L20 20C18.9697 21.0302 17.4318 22.5682 16.5217 23.4783L39.7889 22.9069C39.9272 21.9577 40 20.9874 40 20C40 19.0427 39.9312 18.1016 39.8011 17.1801V17.1801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0C14.5447 0 9.60047 2.18516 5.99219 5.72672H34.0078C30.3995 2.18516 25.4553 0 20 0Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1801 17.1801H39.8011C39.5157 15.1584 38.9285 13.2338 38.0857 11.4534H11.4533L17.1801 17.1801Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3663 28.6337H38.0451C38.8977 26.8546 39.4943 24.9299 39.7889 22.907H17.0931C14.8753 25.1247 12.9958 27.0042 11.3663 28.6337Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C25.4105 40 30.3183 37.8506 33.9186 34.3602H6.0813C9.68161 37.8506 14.5894 40 20 40Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1418 4.68237C6.69719 5.05597 6.26821 5.44761 5.85782 5.85784L20 20L5.85782 34.1422C6.26813 34.5525 6.69719 34.9441 7.1418 35.3177L22.4595 20L7.1418 4.68237Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04099 14.7826L9.33591 18.7682H13.5269L10.1365 21.2317L11.4315 25.2174L8.04099 22.7541L4.65044 25.2174L5.9456 21.2317L2.55521 18.7682H6.74599L8.04099 14.7826Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.603 20.3261L8.22813 19.1305C8.22813 19.1305 7.97875 16.7912 7.96367 16.7119C7.84914 16.1085 7.31891 15.6522 6.68219 15.6522C5.96188 15.6522 5.37781 16.2362 5.37781 16.9566C5.37781 17.076 5.39524 17.1911 5.42531 17.3011L4.47906 18.2537H6.16156C6.16156 20 4.85844 20 4.85844 21.7392L5.58133 23.4783H9.92914L10.6538 21.7392H10.6535C10.7261 21.5723 10.7702 21.4002 10.7884 21.2282C11.413 20.9756 11.603 20.3261 11.603 20.3261V20.3261Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZimbabwe);
export default __webpack_public_path__ + "static/media/zimbabwe.2dd150768a39926ac6cea3c9497c39d1.svg";
export { ForwardRef as ReactComponent };